import { createFileRoute } from "@tanstack/react-router";

import { STATUS_TABS } from "@/features/orders/statusMap";

type OrdersSearch = { q?: string | undefined; status?: string | undefined; tab?: "schedule-waits" | undefined };

/**
 * `?status=` mở sẵn một thẻ của màn Đơn hàng (bản tin sáng dẫn tới thẻ "Chưa
 * khép", QĐ 0292). Chỉ nhận đúng giá trị của một thẻ CÓ THẬT: giá trị lạ mà cho
 * qua thì danh sách gửi nó xuống máy chủ như một trạng thái và hiện trang rỗng
 * không lời giải thích.
 */
const TAB_VALUES = new Set(STATUS_TABS.map((t) => t.value));

export const Route = createFileRoute("/_app/orders/")({
  validateSearch: (search: Record<string, unknown>): OrdersSearch => ({
    q: typeof search.q === "string" && search.q.trim() ? search.q.trim() : undefined,
    status: typeof search.status === "string" && TAB_VALUES.has(search.status) ? search.status : undefined,
    // Chuông "khách đã cọc chưa có lịch" (QĐ 0489) dẫn thẳng tới thẻ đó.
    tab: search.tab === "schedule-waits" ? "schedule-waits" : undefined,
  }),
});
